export default __webpack_public_path__ + "static/confetti-stamps-small-8bebf79871bdeccb5cfbe6b39a89a298.svg";